import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchDashboard } from '../../store/actions/dashboard';
import styles from './Dashboard.module.css';

import Spinner from '../../components/UI/Spinner/Spinner';
import View from '../../components/View/View';
import Navbar from '../../components/View/Navbar/Navbar';
import NavbarRight from '../../components/View/Navbar/NavbarRight/NavbarRight';
import NavbarTitle from '../../components/View/Navbar/NavbarTitle/NavbarTitle';
import NavbarLeft from '../../components/View/Navbar/NavbarLeft/NavbarLeft';
import DrawerToggler from '../../components/View/SideDrawer/DrawerToggler/DrawerToggler';
import Page from '../../components/View/Page/Page';
import PageContent from '../../components/View/PageContent/PageContent';

import IOSInstallBanner from '../../components/Dashboard/IOSInstallBanner/IOSInstallBanner';
import HeaderCard from '../../components/Dashboard/HeaderCard/HeaderCard';
import TenureStats from '../../components/Dashboard/TenureStats/TenureStats';
import QuickStats from '../../components/Dashboard/QuickStats/QuickStats';
import CurrentPlans from '../../components/Dashboard/CurrentPlans/CurrentPlans';
import UpcomingSessions from '../../components/Dashboard/UpcomingSessions/UpcomingSessions';
import WeightProgress from '../../components/Dashboard/WeightProgress/WeightProgress';
import ProgressSparklines from '../../components/Dashboard/ProgressSparklines/ProgressSparklines';
import GymRanking from '../../components/Dashboard/GymRanking/GymRanking';
import DemographicComparison from '../../components/Dashboard/DemographicComparison/DemographicComparison';
import TotalTonnage from '../../components/Dashboard/TotalTonnage/TotalTonnage';
import QuickLinks from '../../components/Dashboard/QuickLinks/QuickLinks';
import Goals from '../../components/Dashboard/Goals/Goals';
import ContentLibrary from '../../components/Dashboard/ContentLibrary/ContentLibrary';
import InactiveMemberView from '../../components/Dashboard/InactiveMemberView/InactiveMemberView';

class Dashboard extends Component {
  state = {
    showSideDrawer: false,
  };

  componentDidMount() {
    this.props.fetchDashboard();
  }

  sideDrawerClosedHandler = () => this.setState({ showSideDrawer: false });
  sideDrawerTogglerHandler = () => this.setState(prevState => ({ showSideDrawer: !prevState.showSideDrawer }));

  render() {
    const { loading, data } = this.props;

    const pike13 = data ? data.pike13 : null;
    const tenure = pike13 ? pike13.tenure : null;
    const scheduleUrl = pike13
      ? `https://${pike13.subdomain}.pike13.com/people/${pike13.person_id}/upcoming`
      : null;
    const accountUrl = pike13
      ? `https://${pike13.subdomain}.pike13.com/people/${pike13.person_id}/balances`
      : null;

    return (
      <View
        showSideDrawer={this.state.showSideDrawer}
        sideDrawerClosedHandler={this.sideDrawerClosedHandler}
      >
        <Navbar>
          <NavbarLeft>
            <DrawerToggler clicked={this.sideDrawerTogglerHandler} />
          </NavbarLeft>
          <NavbarTitle title="Dashboard" leftOffset />
          <NavbarRight />
        </Navbar>
        <Page>
          {loading && (
            <PageContent withNavbar>
              <Spinner />
            </PageContent>
          )}
          {!loading && data && (
            <PageContent withNavbar>
              <div className={styles.Dashboard}>
                <IOSInstallBanner />
                <HeaderCard
                  member={data.pike13_member}
                  logbook={data.logbook}
                  hasMembership={data.has_membership}
                />

                {!data.has_membership && (
                  <InactiveMemberView member={data.pike13_member} />
                )}

                {data.has_membership && (
                  <>
                    {tenure && (
                      <TenureStats
                        tenure={tenure}
                        totalWorkouts={data.logbook ? data.logbook.total_workouts : null}
                        streak={data.streak}
                      />
                    )}

                    {!tenure && data.logbook && (
                      <QuickStats logbook={data.logbook} streak={data.streak} />
                    )}

                    {tenure && tenure.current_plans.length > 0 && (
                      <CurrentPlans plans={tenure.current_plans} accountUrl={accountUrl} />
                    )}

                    {pike13 && (
                      <UpcomingSessions
                        sessions={pike13.upcoming_sessions}
                        scheduleUrl={scheduleUrl}
                      />
                    )}

                    {data.logbook && (
                      <WeightProgress logbook={data.logbook} />
                    )}

                    {data.logbook && (
                      <ProgressSparklines logbook={data.logbook} />
                    )}

                    <Goals />

                    <ContentLibrary />

                    {data.leaderboard && data.leaderboard.length > 0 && (
                      <GymRanking leaderboard={data.leaderboard} />
                    )}

                    {data.comparison && data.comparison.length > 0 && (
                      <DemographicComparison comparison={data.comparison} />
                    )}

                    {data.logbook && data.logbook.total_pounds_lifted != null && (
                      <TotalTonnage total={data.logbook.total_pounds_lifted} />
                    )}

                    <QuickLinks
                      scheduleUrl={scheduleUrl}
                      accountUrl={accountUrl}
                      gymName={data.pike13_member && data.pike13_member.gym_name}
                    />
                  </>
                )}
              </div>
            </PageContent>
          )}
        </Page>
      </View>
    );
  }
}

const mapStateToProps = reduxState => ({
  loading: reduxState.dashboard._loading,
  data: reduxState.dashboard.data,
});

const mapDispatchToProps = {
  fetchDashboard,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Dashboard)
);
